import { Box, Grid, Typography } from '@mui/material'
import React, { useState } from 'react'
import { Technology } from '../../store/types'
import { formatTechnologyType } from '../../store/utils'
import TechnologyPopup from '../Popup/TechnologyPopup'
import DefaultTechnologyImage from '../Logo/DefaultTechnologyLogo'

type TechnologyTileProps = {
  isCollapsed: boolean
  technology: Technology
}

const TechnologyTile = ({ isCollapsed, technology }: TechnologyTileProps) => {
  const textEllipsis = { overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', maxWidth: '85px' }

  const [menuOpen, setMenuOpen] = useState(false)

  return (
    <Grid item xs={12} sm={6} md={4} lg={3} xl={2} sx={{ padding: 1 }} zeroMinWidth>
      <TechnologyPopup technology={technology} isCollapsed={isCollapsed} menuOpen={menuOpen} setMenuOpen={setMenuOpen}>
        {technology.logo === '' || technology.logo === null || technology.logo === 'null' ? (
          <DefaultTechnologyImage size={30} />
        ) : (
          <Box
            component="img"
            alt={`${technology.name} logo`}
            src={`data:image/${technology.extension};base64,${technology.logo}`}
            sx={{ width: 30, height: 30, borderRadius: 30, bgcolor: 'white', objectFit: 'contain' }}
          />
        )}
        <Box
          sx={{
            display: isCollapsed ? 'none' : 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
          }}
        >
          <Typography variant={'body1'} fontWeight={700} sx={textEllipsis}>
            {technology.name}
          </Typography>
          <Typography variant={'caption'} sx={textEllipsis}>
            {formatTechnologyType(technology.type)}
          </Typography>
        </Box>
      </TechnologyPopup>
    </Grid>
  )
}

export default TechnologyTile
